import * as yup from 'yup';

const local_language = localStorage.getItem('lang')

const BlockServiceValidation: any = yup.object().shape({
    start_date: yup.string().nullable()
        .test({
            name: 'start_date',
            exclusive: true,
            message: local_language == "alb" ? "Kërkohet koha e fillimit" : 'Start time is required',
            test: function (value: any) {
                const startDate = this.resolve(yup.ref('start_time'));
                const endDate = this.resolve(yup.ref('end_time'));
                if (startDate || endDate) {
                    return value;
                } else {
                    return true;
                }
            },
        }),
    end_date: yup.string().nullable()
        .test({
            name: 'end_date',
            exclusive: true,
            message: local_language == "alb" ? "Kërkohet koha e përfundimit" : 'End time is required',
            test: function (value: any) {
                const endDate = this.resolve(yup.ref('end_time'));

                if (endDate) {
                    return value;
                } else {
                    return true;
                }
            },
        }),




    Unavailability: yup.string().required(local_language == "alb" ? "Kërkohet zgjedhja e arsyes" : 'Select Reason is required'),
    close_services: yup.string().required(local_language == "alb" ? "Kërkohet zgjedhja e arsyes" :'Select Reason is required')
    // Unavailability: yup.string().required('Select Reason is required').oneOf(['1', '2'], 'Please select a valid reason'),
    // close_services: yup.string().required('Select Reason is required').oneOf(['1', '2'], 'This is required field'),


});

export default BlockServiceValidation;